<template>
    <section id="home-slide-try" class="py-5 text-center container-fluid">
        <button type="button" class="btn btn-lg btn-block btn-secondary" @click="goToApp()">{{ gettext("Essayer Octolo") }}</button>
    </section>
</template>

<script>
export default {
    methods: {
        goToApp(){ window.location = "/app/"; },
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";
#home-slide-try {
    background-color: $primary;
}
</style>
